/**
 * ============================================================
 * TRESTLE™ Workspace Configuration
 * ------------------------------------------------------------
 * Central configuration for the Workspace.
 *
 * Brand        : Diafemme®
 * Module       : TRESTLE™ Workspace
 * File         : trestle-workspace-config.js
 *
 * Version      : 1.0
 * Status       : PRODUCTION
 *
 * Responsibilities
 * ------------------------------------------------------------
 * • API Configuration
 * • Membership Constants
 * • Local Storage Keys
 * • Widget IDs
 * • Workspace Defaults
 * • Timeouts
 * • Routes
 *
 * This file contains CONFIGURATION ONLY.
 * No business logic.
 * No API calls.
 * No DOM manipulation.
 * ============================================================
 */

'use strict';

const TrestleConfig = Object.freeze({
    

    /*==========================================================
    APPLICATION
    ==========================================================*/

    APP:{

        NAME:"TRESTLE",

        VERSION:"2.0",

        BRAND:"Diafemme"

    },



    /*==========================================================
    API
    ==========================================================*/

    API:{

        BASE_URL:"https://script.google.com/macros/s/AKfycbzpSAQfsqxntX5xQKsC8q0By1ebqS7tPex8_rPaPFYGTPIUk3633-z5YNKcLBV5RbGM/exec",    // Google Apps Script Web App URL //

        VERSION:"2.0",

        TIMEOUT:30000,

        CONTENT_TYPE:"application/json"

    },



    /*==========================================================
    MEMBERSHIP
    ==========================================================*/

    MEMBERSHIP:{

        FREE:"FREE",

        PREMIUM:"PREMIUM",

        CORPORATE:"CORPORATE",

        ADMIN:"ADMIN"

    },



    /*==========================================================
    LOCAL STORAGE
    ==========================================================*/

    STORAGE:{

        REMINDERS:"trestle-reminders",

        TODAY_PROMISE:"trestle-today-promise",

        LAST_PROMISE_DATE:"trestle-last-promise-date",

        DASHBOARD_CACHE:"trestle-dashboard-cache",

        WORKSPACE_CACHE:"trestle-workspace-cache"

       

    },



   /*==========================================================
     WORKSPACE
   ==========================================================*/

   WORKSPACE:{

    MAX_REMINDERS:10,

    MAX_RECOMMENDATIONS:4,

    MAX_EXPLORE_ITEMS:4,

    CACHE_MINUTES:15,

    DEFAULT_MOOD:"😐 Same",

    DEFAULT_MEMBERSHIP:"FREE"

},



    /*==========================================================
    WIDGET IDS
    ==========================================================*/

    WIDGETS:{

        HERO:"tr-workspace-hero",

        PROMISE:"tr-workspace-promise",

        WHY_TODAY:"tr-workspace-why-today",

        QUICK_ACTIONS:"tr-workspace-quick-actions",

        JOURNEY:"tr-workspace-journey",

        TODAY_HEALTH:"tr-workspace-health",

        INSIGHT:"tr-workspace-insight",

        RECOMMENDATIONS:"tr-workspace-recommendations",

        EXPLORE:"tr-workspace-explore",

        REMIND_ME:"tr-workspace-remind-me",

        REFLECTION:"tr-workspace-reflection",

        THOUGHT:"tr-workspace-thought"

    },



    /*==========================================================
API ACTIONS
==========================================================*/

ACTIONS:{

    LOGIN:"LOGIN",

    LOAD_DASHBOARD:"LOAD_DASHBOARD",

    LOAD_USER:"LOAD_USER",

    CREATE_USER:"CREATE_USER",

    LOAD_WORKSPACE:"LOAD_WORKSPACE",

    CREATE_WORKSPACE:"CREATE_WORKSPACE",

    LOAD_HEALTH_LOG:"LOAD_HEALTH_LOG",

    CREATE_HEALTH_LOG:"CREATE_HEALTH_LOG",

    LOAD_HEALTH_PROFILE:"LOAD_HEALTH_PROFILE",

    SAVE_HEALTH_PROFILE:"SAVE_HEALTH_PROFILE",

    SAVE_USER_PROFILE:"SAVE_USER_PROFILE",

    LOAD_REPORT:"LOAD_REPORT",

    CREATE_REPORT:"CREATE_REPORT",

    CREATE_AUDIT_LOG:"CREATE_AUDIT_LOG",

    CREATE_SYSTEM_LOG:"CREATE_SYSTEM_LOG",

    QUEUE_EMAIL:"QUEUE_EMAIL",

    CREATE_SECURE_LINK:"CREATE_SECURE_LINK",

    LOAD_DAILY_INTENTION:"LOAD_DAILY_INTENTION",

    CREATE_DAILY_INTENTION:"CREATE_DAILY_INTENTION"

},



    /*==========================================================
    ROUTES
    ==========================================================*/

    ROUTES:{

        HOME:"/",

        WORKSPACE:"/pages/trestle-workspace",

        MEMBERSHIP:"/pages/trestle-membership",

        ACCOUNT:"/account"

    },



    /*==========================================================
    PROMISES
    ==========================================================*/

    PROMISES:[

        "Better Energy",

        "Better Focus",

        "Better Calm",

        "Better Balance",

        "Better Nourishment",

        "Better Movement"

    ],

    /*==========================================================
    QUICK ACTIONS
==========================================================*/

    QUICK_ACTIONS:[

    "Blood Sugar",

    "Meal",

    "Water",

    "Activity",

    "Medication"

   ],

   /*==========================================================
TODAY'S HEALTH
==========================================================*/

TODAYS_HEALTH:[

    "Blood Sugar",

    "Mood",

    "Hydration",

    "Activity",

    "Medication"

],

/*==========================================================
REFLECTION
==========================================================*/

REFLECTION_OPTIONS:[

    "😊 Better",

    "😐 Same",

    "😔 Tired"

],

    /*==========================================================
    EVENTS
    ==========================================================*/

    EVENTS:{

        READY:"workspace-ready",

        LOADED:"workspace-loaded",

        ERROR:"workspace-error"

    },

    /*==========================================================
REPORTS
==========================================================*/

REPORTS:{

    EVENING:"EVENING",

    WEEKLY:"WEEKLY",

    MONTHLY:"MONTHLY"

},

});
window.TrestleConfig = TrestleConfig;

console.log("TrestleConfig Loaded");
console.log(TrestleConfig);
console.log(TrestleConfig.API.BASE_URL);
